// extracted by mini-css-extract-plugin
export default {"content":"Header_content__8sQm-","header":"Header_header__OKWO7","fixed":"Header_fixed__O++Pp","hidden":"Header_hidden__LWXR0","title":"Header_title__l+wMf"};